import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page9() {
  useEffect(() => {
    document.title = "Маяк — Страница 8"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page7" />
        <ForwardLink href="/page9" />
      </div>

      <p style={{ textAlign: "right" }}>8.</p>
      <p>
        Как только они выпивают: МОЛОДОГО РВЕТ! Ужасный вкус. Он<br/>
        сплевывает в свою чашку. Немного на пол.
      </p>
      <p>СТАРИК упивается его неудачей.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да. Цистерна нуждается в осмотре.<br/>
        Одна из твоих обязанностей, парень. Или<br/>
        ты сам об этом не читал?<br/>
        Полировать, чистить. Чистить и<br/>
        полировать. Ты почистишь медь<br/>
        и часовой механизм и после можешь привести в порядок<br/>
        помещения. И снаружи еще<br/>
        многое предстоит починить.
      </p>
      <p>МОЛОДОЙ кивает, его рвота проходит.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Слышишь, парень?
      </p>
      <p style={{ textAlign: "center" }}>
        Молодой<br/>
        Дасэр--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (поправляет его)<br/>
        “Есть, сэр!”
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p>
        СТАРИК начинает есть свой ужин. Счастливый. Его привычки немного<br/>
        неотесанные.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Когда туман рассеется, заступишь<br/>
        на собачью вахту--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Собачью что? Надеялся<br/>
        пойти на фонарь.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        <u>Я</u> присматриваю за светом.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        По правилам смены чередуются--
      </p>
      <p>
        СТАРИК поразительно суров. Не моргает. Не трясется. Кусочек скрода<br/>
        висит на его бороде.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Это середина смены, которой стоит опасаться,<br/>
        парень: с ночи до утра. <u>Моя</u> смена.<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>8.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page7" />
        <ForwardLink href="/page9" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708107309/the-lighthouse-script/g2ixevpxhnpdikqdlryk.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page9;
